import { useState, useCallback, useEffect } from 'react';
import { AxiosError } from 'axios';
import { appAxios } from 'api/axios';
import { sendCatchFeedback } from 'functions/feedback';

export interface BankOption {
  label: string;
  value: string;
}

export const useBanks = () => {
  const [bankOptions, setBankOptions] = useState<BankOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchBanks = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await appAxios.get('/get-banks');
      const options = response.data?.data?.map((option: any) => ({
        label: option.name,
        value: option.code,
      }));
      setBankOptions(options);
    } catch (err) {
      const errorMessage =
        err instanceof AxiosError
          ? err.response?.data?.message || err.message
          : 'An unexpected error occurred';
      setError(errorMessage);
      sendCatchFeedback(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBanks();
  }, [fetchBanks]);

  return {
    bankOptions,
    loading,
    error,
    refetch: fetchBanks,
  };
};
